export default __webpack_public_path__ + "static/layout-do-dark-3e9780c930529ae7e5d9d410eec95eb4.png";